import { render, staticRenderFns } from "./providerSendInvite.vue?vue&type=template&id=744171d2&scoped=true&"
import script from "./providerSendInvite.vue?vue&type=script&lang=babel&"
export * from "./providerSendInvite.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744171d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
